// src/mixins/GoogleSlideMixin.js
import { mapActions } from 'vuex'
import Sentry from '@sentry/vue'
import Util from '@/util'
import SlidesUndoRedoUtil from '@/utils/SlidesUndoRedo.util'

export default {

  methods: {
    ...mapActions(['createNewGoogleSlide', 'updateActiveGoogleSlide', 'createLeaderboardGoogleSlide']),
    async _createNewSlide(item, addCorrectOption) {
      try {
        const beforeCreateSlides = JSON.parse(JSON.stringify(this.presentation.slides.filter(
          (s) => s.id != null,
        )))

        const dataPayload = this._getPayloadCreateNewSlide(item, addCorrectOption)
        const res = await this.createNewGoogleSlide({ dataPayload, item })
        this._handleAfterCreateNewSlide(item, res)
        this.updateActiveGoogleSlide(res)
        this.createLeaderboardGoogleSlide(res.body)
        const afterCreateSlides = JSON.parse(JSON.stringify(this.presentation.slides))
        SlidesUndoRedoUtil.backupCreateSlides(this, beforeCreateSlides, afterCreateSlides, res.body)
      } catch (error) {
        Sentry.captureException(error)
        Util.handleError(error.body ? error.body.message : error)
      }
    },
  },
}
